<template>
  <div class="register-page mx-auto">

       <header style="background: rgb(247, 250, 252)" class="border-b">
          <container class="py-8 md:py-16">
            <div style="max-width: 720px" class="mx-auto">
               <ul class="breadcrumbs flex mb-4">
                <li><router-link to="/" class="text-awro-700" >{{ $t('nav.home') }}</router-link></li>
                <li class="mx-1">/</li>
                <li><router-link to="/register"  class="text-awro-700" active-class="router-active">{{$t('btn.register')}}</router-link></li>
              </ul>
              <head-line :level="1" :size="1" :bold="true">{{$t('btn.register')}}</head-line>
            </div>
          </container>
      </header>

      <container class="pt-12 pb-16">
           <div style="max-width: 720px" class="mx-auto">
             <form>
              <div class="group">
                  <head-line :level="3" :size="3"  :bold="true" class="mb-6"> {{ $t("form.group.personal") }}</head-line>
                  <div class="group-fields">
                    <div class="lg:flex justify-between">
                      <div class="mb-4 lg:w-1/2" :class="[{'lg:mr-4': !isRtl},{'lg:ml-4': isRtl}]">
                        <label class="block text-support-700 mb-1" for="FirstName">{{ $t("form.field.fname") }}</label>
                        <input ref="FirstName" type="text" id="FirstName" name="FirstName" v-model.trim="$v.FirstName.$model"
                            class="w-full border-2  px-4 py-2 rounded focus:outline-none"
                            :class="[{'border-red-600 form-group--error':$v.FirstName.$error},{'focus:border-awro-600 hover:border-awro-600':!$v.FirstName.$error}]"
                            />
                        <div class="error" v-if="$v.FirstName.$error">
                             {{ $t("form.error.required") }}
                        </div>
                      </div>
                      <div class="mb-4 lg:w-1/2">
                        <label class="block text-support-700 mb-1" for="SecondName">{{ $t("form.field.mname") }}</label>
                        <input  ref="SecondName" type="text" id="SecondName" name="SecondName"
                        v-model.trim="$v.SecondName.$model"
                        class="w-full border-2 px-4 py-2 rounded focus:outline-none"
                        :class="[{'border-red-600 form-group--error':$v.SecondName.$error},{'focus:border-awro-600 hover:border-awro-600':!$v.SecondName.$error}]"
                        />
                        <div class="error" v-if="$v.SecondName.$error">
                             {{ $t("form.error.required") }}
                        </div>
                      </div>
                    </div>
                    <div class="mb-4">
                        <label class="block text-support-700 mb-1" for="ThirdName">{{ $t("form.field.lname") }}</label>
                        <input  ref="ThirdName" type="text" id="ThirdName" name="ThirdName"
                        v-model.trim="$v.ThirdName.$model"
                        class="w-full  border-2  px-4 py-2 rounded focus:outline-none"
                        :class="[{'border-red-600 form-group--error':$v.ThirdName.$error},{'focus:border-awro-600 hover:border-awro-600':!$v.ThirdName.$error}]"
                        />
                         <div class="error" v-if="$v.ThirdName.$error">
                           {{ $t("form.error.required") }}
                        </div>
                    </div>

                    <div class="mb-4">
                        <label class="block text-support-700 mb-1" for="gender">{{ $t("form.field.gender") }}</label>
                        <div class="inline-flex justify-between w-40">
                          <label><input type="radio" id="gender" name="gender" class="align-baseline" value="0" checked="checked" /> <span class="mx-1">{{ $t("form.value.gender[0]") }}</span></label>
                          <label><input type="radio" id="gender" name="gender" class="align-baseline" value="1"/> <span class="mx-1">{{ $t("form.value.gender[1]") }}</span></label>
                        </div>
                    </div>
                  </div>
              </div>

              <hr class="my-10" />

              <div class="group">
                  <head-line :level="3" :size="3"  :bold="true" class="mb-6">{{ $t("form.group.address") }}</head-line>
                  <div class="group-fields">
                    <div class="lg:flex justify-between">
                    <div class="mb-4 lg:w-1/2" :class="[{'lg:mr-4': !isRtl},{'lg:ml-4': isRtl}]">
                      <label class="block text-support-700 mb-1" for="CityId">{{ $t("form.field.city") }}</label>
                      <div class="inline-block w-full relative mb-4 md:mb-0" :class="[{'md:mr-3': !isRtl}, {'md:ml-3': isRtl}]">
                        <select
                        ref="CityId"
                        class="block
                        appearance-none
                        w-full bg-white border-2 hover:border-awro-600 px-4 py-2 pr-8 rounded focus:outline-none focus:border-awro-600"
                        name="CityId"
                        id="CityId"
                        v-model.trim="$v.CityId.$model"
                        >

                          <option value="1">{{ $t("form.value.city[0]") }}</option>
                          <option value="2">{{ $t("form.value.city[1]") }}</option>
                          <option value="3">{{ $t("form.value.city[2]") }}</option>
                        </select>
                        <div class="pointer-events-none absolute inset-y-0  flex items-center px-2 text-gray-700" :class="[{'right-0': !isRtl}, {'left-0' : isRtl}]">
                          <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                        </div>
                      </div>
                    </div>
                    <div class="mb-4 lg:w-1/2">
                      <label class="block text-support-700 mb-1" for="Mobile">{{ $t("form.field.phone") }}</label>
                      <input  ref="Mobile" type="text" id="Mobile" name="Mobile"
                      v-model.trim="$v.Mobile.$model"
                      :class="[{'border-red-600 form-group--error':$v.Mobile.$error},{'focus:border-awro-600 hover:border-awro-600':!$v.Mobile.$error}]"
                      class="w-full border-2 px-4 py-2 rounded focus:outline-none" />
                      <div class="error" v-if="$v.Mobile.$error">
                            {{ $t("form.error.phone") }}
                      </div>
                    </div>
                  </div>
                  <div class="mb-4">
                      <label class="block text-support-700 mb-1" for="Email">{{ $t("form.field.email") }}</label>
                      <input type="email" id="Email" name="Email"
                      v-model.trim="$v.Email.$model"
                      ref="Email"
                      :class="[{'border-red-600 form-group--error':$v.Email.$error},{'focus:border-awro-600 hover:border-awro-600':!$v.Email.$error}]"
                      class="w-full border-2 px-4 py-2 rounded focus:outline-none"
                       />
                      <div class="error" v-if="$v.Email.$error">
                            {{ $t("form.error.email") }}
                      </div>
                  </div>
                </div>
              </div>

              <hr class="my-10" />

              <div class="group">
                  <head-line :level="3" :size="3"  :bold="true" class="mb-6">{{ $t("form.group.complete") }}</head-line>
                  <div class="group-fields">
                    <div class="lg:flex justify-between">
                    <div class="mb-4 lg:w-1/2" :class="[{'lg:mr-4': !isRtl},{'lg:ml-4': isRtl}]">
                      <label class="block text-support-700 mb-1" for="CenterType">{{ $t("form.field.ptype") }}</label>
                      <div class="inline-block w-full relative mb-4 md:mb-0"   :class="[{'md:mr-3': !isRtl}, {'md:ml-3': isRtl}]">
                        <select class="block
                        appearance-none
                        w-full bg-white border-2 hover:border-awro-600 px-4 py-2 pr-8 rounded focus:outline-none focus:border-awro-600"
                        name="CenterType"
                        id="CenterType"
                        ref="CenterType"
                        v-model.trim="$v.CenterType.$model"
                        :class="[{'border-red-600':$v.CenterType.$error},{'focus:border-awro-600 hover:border-awro-600':!$v.CenterType.$error}]"
                        >
                            <option value="0">{{ $t("form.value.ptype[0]") }}</option>
                            <option value="1">{{ $t("form.value.ptype[1]") }} </option>
                            <option value="2">{{ $t("form.value.ptype[2]") }}</option>
                            <option value="3">{{ $t("form.value.ptype[3]") }}</option>
                            <option value="4">{{ $t("form.value.ptype[4]") }}</option>
                            <option value="5">{{ $t("form.value.ptype[5]") }}</option>
                            <option value="6">{{ $t("form.value.ptype[6]") }}</option>
                            <option value="7">{{ $t("form.value.ptype[7]") }}</option>
                            <option value="8">{{ $t("form.value.ptype[8]") }}</option>
                            <option value="9">{{ $t("form.value.ptype[9]") }}</option>
                            <option value="10">{{ $t("form.value.ptype[10]") }}</option>
                            <option value="11">{{ $t("form.value.ptype[11]") }}</option>
                            <option value="12">{{ $t("form.value.ptype[12]") }}</option>
                        </select>
                        <div class="pointer-events-none absolute inset-y-0  flex items-center px-2 text-gray-700" :class="[{'right-0': !isRtl}, {'left-0' : isRtl}]">
                          <svg class="fill-current h-4 w-4" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path d="M9.293 12.95l.707.707L15.657 8l-1.414-1.414L10 10.828 5.757 6.586 4.343 8z"/></svg>
                        </div>
                      </div>
                    </div>
                    <div class="mb-4 lg:w-1/2">
                      <label class="block text-support-700 mb-1" for="PoliClinicName">{{ $t("form.field.pname") }}</label>
                      <input  ref="PoliClinicName" type="text" id="PoliClinicName" name="PoliClinicName"
                       v-model.trim="$v.PoliClinicName.$model"
                      :class="[{'border-red-600  form-group--error':$v.PoliClinicName.$error},{'focus:border-awro-600 hover:border-awro-600':!$v.PoliClinicName.$error}]"
                      class="w-full border-2 px-4 py-2 rounded focus:outline-none" />
                      <div class="error" v-if="$v.PoliClinicName.$error">
                             {{ $t("form.error.required") }}.
                      </div>
                    </div>
                  </div>
                  <div class="mb-4">
                      <label class="block text-support-700 mb-1" for="PoliClinicAddress">{{ $t("form.field.address") }}</label>
                      <input  ref="PoliClinicAddress" type="text" id="PoliClinicAddress" name="PoliClinicAddress"
                      v-model.trim="$v.PoliClinicAddress.$model"
                       :class="[{'border-red-600  form-group--error':$v.PoliClinicAddress.$error},{'focus:border-awro-600 hover:border-awro-600':!$v.PoliClinicAddress.$error}]"
                      class="w-full border-2 px-4 py-2 rounded focus:outline-none" />
                      <div class="error" v-if="$v.PoliClinicAddress.$error">
                             {{ $t("form.error.required") }}.
                      </div>
                  </div>
                  <div class="mb-6">
                      <label class="block text-support-700 mb-1" for="Description">{{ $t("form.field.more") }}</label>
                      <textarea  ref="Description" id="Description" name="Description"
                      v-model.trim="$v.Description.$model"
                      :class="[{'border-red-600  form-group--error':$v.Description.$error},{'focus:border-awro-600 hover:border-awro-600':!$v.Description.$error}]"
                      class="w-full border-2 px-4 py-2 rounded focus:outline-none" rows="4"></textarea>
                      <div class="error" v-if="$v.Description.$error">
                        {{ $t("form.error.required") }}
                      </div>
                  </div>
                  <div class="mb-6">
                    <div  v-if="serverError" class="error mb-4">
                        <div role="alert">
                            <div class="border border-red-400 rounded-b bg-red-100 px-4 py-3 text-red-700">
                                <p>{{ $t("form.error.server") }}</p>
                            </div>
                        </div>
                    </div>
                  </div>
                  <div>
                      <button
                      class="tracking-wide inline-flex items-center  select-none px-6 py-2 rounded"
                      :class="[{'text-gray-500 bg-gray-300 cursor-wait': loading, 'text-awro-100 bg-awro-600 hover:bg-awro-500 shadow ': !loading}]"
                      @click.prevent="register"
                      :disabled="loading"
                      >

                        <svg v-if="loading" width="20" height="20" viewBox="0 0 38 38" xmlns="http://www.w3.org/2000/svg" stroke="#999">
                        <g fill="none" fill-rule="evenodd">
                            <g transform="translate(1 1)" stroke-width="2">
                                <circle stroke-opacity=".5" cx="18" cy="18" r="18"/>
                                <path d="M36 18c0-9.94-8.06-18-18-18">
                                    <animateTransform
                                        attributeName="transform"
                                        type="rotate"
                                        from="0 18 18"
                                        to="360 18 18"
                                        dur="1s"
                                        repeatCount="indefinite"/>
                                </path>
                            </g>
                        </g>
                    </svg>
                        <span v-if="!loading" :class="[{'ml-3': !isRtl && loading},{'mr-3': isRtl && loading}]">
                            {{$t('btn.register')}}
                        </span>
                      </button>
                  </div>
                </div>

              </div>

          </form>
          </div>

      </container>
      <hr/>

     <modal :title="$t('alert.regSuccess.title')" :subtitle="$t('alert.regSuccess.msg')" @close="closeModal" :show-modal="showSuccessModal"></modal>
  </div>
</template>

<script>
import Container from '@/components/Container';
import HeadLine from '@/components/theme/HeadLine'
import {mapGetters} from 'vuex'
import {validationMixin} from 'vuelidate';
import { required, minLength, maxLength, numeric, email } from 'vuelidate/lib/validators'
import Modal from '@/components/Modal'
import NProgress from 'nprogress';
import api from '@/api'

export default {
    name: "Register",
    mixins: [validationMixin],
    components: {Container,HeadLine, Modal},
    computed: {
      ...mapGetters({
        isRtl: ['locale/IS_RTL']
      })
    },
    data() {
      return {
        FirstName: '',
        SecondName: '',
        ThirdName: '',
        Gender: 0,
        CityId: 1,
        Mobile: '',
        Email: '',
        CenterType: 0,
        PoliClinicName: '',
        PoliClinicAddress: '',
        Description: '',
        loading: false,
        showSuccessModal: false,
        showContent: false,
        serverError: false
      }
    },
    validations: {
        FirstName: {required},
        SecondName: {required},
        ThirdName: {required},
        Gender: { required },
        CityId: { required },
        Mobile: {
          required,
          numeric,
          minLength: minLength(10),
          maxLength: maxLength(11)
        },
        Email: {
          required,
          email
        },
        CenterType: { required },
        PoliClinicName: { required },
        PoliClinicAddress: { required },
        Description: { required },

    },
    methods: {
      async register() {
        this.$v.$touch();
        this.showSuccessModal = this.serverError = false;

        if(this.$v.$anyError) {
          this.loading = false;
          var invalidFields = Object.keys(this.$v.$params)
                  .filter(fieldName => this.$v[fieldName].$invalid);
          this.$refs[invalidFields[0]].focus();
          return;
        }


        try {
          this.loading = true;
          let resp = await api.post('/register/centers', this.$data);
          if(resp.status == 200) {
            this.showSuccessModal = true;
          }
        } catch {
          this.serverError = true;
          NProgress.done() 
        } finally {
          this.loading = false;
        }

        
      },
      closeModal() {
        this.resetForm();
        this.$v.$reset();
        this.showSuccessModal = false;
      },
      resetForm() {
        this.FirstName =  '';
        this.SecondName =  '';
        this.ThirdName =  '';
        this.Gender =  0;
        this.CityId =  1;
        this.Mobile =  '';
        this.Email =  '';
        this.CenterType =  0;
        this.PoliClinicName =  '';
        this.PoliClinicAddress =  '';
        this.Description =  '';
        this.serverError = false;
      }
    },
  metaInfo() {
    return {
      title: this.$i18n.t('awronore') + ' | ' + this.$i18n.t('pages.register.title'),
      htmlAttrs: {
        amp: true,
        lang: this.$i18n.locale
      } 
    } 
  }
}
</script>

<style lang="scss">
 .form-group--alert, .form-group--error {
    animation-name: shakeError;
    animation-fill-mode: forwards;
    animation-duration: .6s;
    animation-timing-function: ease-in-out;
}

@keyframes shakeError {
  0% {
    transform: translateX(0); }
  15% {
    transform: translateX(0.375rem); }
  30% {
    transform: translateX(-0.375rem); }
  45% {
    transform: translateX(0.375rem); }
  60% {
    transform: translateX(-0.375rem); }
  75% {
    transform: translateX(0.375rem); }
  90% {
    transform: translateX(-0.375rem); }
  100% {
    transform: translateX(0); } }
</style>
